import { useEffect } from "react";
import { Row, Typography, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import BackButton from "components/BackButton";
import { getProductTypeRequest } from "providers/ProductProvider/slice";
import ManageTab from "./ManageTab";
import EditTab from "./EditTab";
import "./styles.less";

const { TabPane } = Tabs;

const CustomizePage = () => {
  const dispatch = useDispatch();
  const productTypes = useSelector((state) => state.product.productTypes);

  useEffect(() => {
    dispatch(getProductTypeRequest());
  }, [dispatch]);

  return (
    <div className="customize-page-wrapper">
      <Row className="customize-page-header" justify="space-between">
        <div className="back-btn">
          <BackButton />
          <Typography.Title level={4}>
            Quản lý Loại & Dòng sản phẩm
          </Typography.Title>
        </div>
      </Row>
      <div className="content-container">
        <Tabs defaultActiveKey="manage" type="card">
          <TabPane tab="Quản lý" key="manage">
            <ManageTab productTypes={productTypes} />
          </TabPane>
          <TabPane tab="Chỉnh sửa" key="edit">
            <EditTab productTypes={productTypes} />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default CustomizePage;
